var map = {
	"./2.jpg": "c01a",
	"./Cq2BFNQXYAU7vb_.jpg": "0c23",
	"./GettyImages-771616379-5af9cda5ba61770036390145.jpg": "3078",
	"./Paseos-imperdibles-en-Punta-del-Este-para-disfrutar-de-la-ciudad-a-pleno.png": "62e6",
	"./Punta-del-este-2012.jpg": "dbe1",
	"./dedos.jpg": "d512",
	"./maxresdefault.jpg": "3a87",
	"./punta-del-este-4.jpg": "e6da",
	"./punta-del-este-5.jpg": "c95f",
	"./punta-del-este.jpg": "581d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bd56";